import { FormSelectId, FormSelectIdProps } from '@nexelem/form-components';
import { useCustomTranslation } from '../../../hooks';
import { useUsers } from '../../../queryHooks/useUsers';

type FormReleaserSelectProps = Omit<FormSelectIdProps, 'label' | 'options' | 'placeholder'>;

export const FormReleaserSelect = (props: FormReleaserSelectProps) => {
  const { t, tWrapper } = useCustomTranslation('warehouse.outboundDeliveries.filters');
  const { data, isLoading } = useUsers();

  const options = data?.map(({ firstName, lastName, id = 0 }) => {
    return { id, label: `${lastName} ${firstName}` };
  });

  return (
    <FormSelectId
      {...props}
      label={tWrapper('releaser')}
      loading={isLoading}
      options={options}
      placeholder={t('components.filters.searchOrSelect')}
    />
  );
};
